import React from "react";
import SectionMessage from "@atlaskit/section-message";
import { SectionHeading } from "../../../utils/styles";
export var Announcement = function () { return (React.createElement(SectionMessage, { title: "", appearance: "change" },
    React.createElement(SectionHeading, null, "NEW! Instant Wargames"),
    "New to wargames and Brahmos? You can now run wargames in one click, without creating a template! Check out a few faults below.")); };
